import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles/base.css';
import './styles/components.css';

/**
 * Data-router i stället för <BrowserRouter>. Appens egna <Routes> ligger kvar
 * i App — det här är bara skalet runt dem. Skälet till bytet är `useBlocker`,
 * som stoppar en navigering med osparade ändringar i adminformuläret. Den
 * finns bara i en data-router, och utan den kan man klicka bort en halvskriven
 * lektion utan att appen hinner säga ifrån.
 */
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
